module.exports = ".flex-between {\n  width: 100%;\n  height: 150px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n  .flex-between .imagem {\n    width: 20%;\n    height: 100px;\n    background-size: contain;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-color: transparent; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/rodape/rodape.component.scss
// module id = ./src/app/components/rodape/rodape.component.scss
// module chunks = main